const labelsByDomain = new Map<string, string[]>();
const listeners = new Set<() => void>();
const discardCallbacks = new Map<string, () => void>();
let approvedNavigation = false;
let activeLabels: string[] = [];

export const getWorkspaceDirtyLabels = (): string[] => activeLabels;

export const setWorkspaceDirtyLabels = (domain: string, labels: string[]): void => {
  const previous = labelsByDomain.get(domain) || [];
  if (previous.length === labels.length && previous.every((label, index) => label === labels[index])) return;
  if (labels.length) labelsByDomain.set(domain, labels);
  else labelsByDomain.delete(domain);
  const nextLabels = Array.from(new Set(Array.from(labelsByDomain.values()).flat()));
  if (activeLabels.length === nextLabels.length && activeLabels.every((label, index) => label === nextLabels[index])) return;
  activeLabels = nextLabels;
  listeners.forEach(listener => listener());
};

export const subscribeWorkspaceDirtyLabels = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const registerWorkspaceDirtyDiscard = (key: string, callback: () => void): (() => void) => {
  discardCallbacks.set(key, callback);
  return () => { if (discardCallbacks.get(key) === callback) discardCallbacks.delete(key); };
};

export const discardWorkspaceDirtyChanges = (): void => {
  Array.from(discardCallbacks.values()).forEach(callback => callback());
};

export const approveNextDirtyNavigation = (): void => { approvedNavigation = true; };
export const clearDirtyNavigationApproval = (): void => { approvedNavigation = false; };
export const consumeDirtyNavigationApproval = (): boolean => {
  const approved = approvedNavigation;
  approvedNavigation = false;
  return approved;
};

export const confirmWorkspaceChange = (): boolean => {
  const labels = getWorkspaceDirtyLabels();
  if (labels.length === 0) return true;
  const confirmed = window.confirm(`Discard unsaved ${labels.join(', ')} and switch workspace?`);
  if (confirmed) discardWorkspaceDirtyChanges();
  return confirmed;
};
